import React, { useEffect, useState } from 'react'
import GaugeChart from './GaugeChart';
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { calculateDateRangeFromDate } from '../../../Utils/DateConverstion';
import { APIConstants } from '../../../Common/APIConstants';
import { TransformGaugeChartData } from '../chartdata.transformers';

const GaugeMain = (props) => {
    const [gauge, setGauge]= useState([
        {
          type: 'gauge',
          title: 'Live Voltage',
          detail: { formatter: 0, valueAnimation: true, fontSize: 10 },
          data: [ { value: 0, name: 'VLLAVG' } ],
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.5, '#e8c25a'], // Yellow – 28000 to 30500
                [0.875, '#048f04'], // Green – 30500 to 33500
                [1, '#fd666d'] // Red – 33500 to 35000
            ]
            }
          },
          min:9000,
          max: 35000,
          pointer: { itemStyle: { color: 'auto' } },
          axisTick: {
            distance: -10,
            length: 8,
            lineStyle: { color: 'rgb(16,12,42)', width: 2 }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: { color: 'rgb(16,12,42)', width: 4 }
          },
          axisLabel: { color: 'inherit', distance: 40, fontSize: 10 }
        },
        {
          type: 'gauge',
          title: 'Live Demand',
          detail: { formatter: 0, valueAnimation: true, fontSize: 10 },
          data: [ { value: 0, name: 'KVAT' } ],
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.583, '#307ef2'], // Blue – 0 to 3500
                [0.75, '#e8c25a'], // Yellow – 3500 to 4500
                [0.833, '#048f04'], // Green – 4500 to 5000
                [1, '#fd666d'] // Red – 5000 to 6000
            ]
            }
          },
          min: 0,
          max: 2000,
          pointer: { itemStyle: { color: 'auto' } },
          axisTick: {
            distance: -10,
            length: 8,
            lineStyle: { color: 'rgb(16,12,42)', width: 2 }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: { color: 'rgb(16,12,42)', width: 4 }
          },
          axisLabel: { color: 'inherit', distance: 40, fontSize: 10 }
        },
        {
          type: 'gauge',
          title: 'Live Current',
          detail: { formatter: 0, valueAnimation: true, fontSize: 10 },
          data: [ { value: 0, name: 'IAVG' } ],
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.625, '#e8c25a'], // Yellow – 0 to 75
                [0.75, '#048f04'], // Green – 75 to 90
                [1, '#fd666d'] // Red – 90 to 120
            ]
            }
          },
          min: 0,
          max: 120,
          pointer: { itemStyle: { color: 'auto' } },
          axisTick: {
            distance: -10,
            length: 8,
            lineStyle: { color: 'rgb(16,12,42)', width: 2 }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: { color: 'rgb(16,12,42)', width: 4 }
          },
          axisLabel: { color: 'inherit', distance: 40, fontSize: 10 }
        },
        {
          type: 'gauge',
          title: 'Live Power Factor',
          detail: { formatter: 0, valueAnimation: true, fontSize: 10 },
          data: [ { value: 0, name: 'PFT' } ],
          axisLine: {
            lineStyle: {
              width: 30,
              color: [
                [0.1667, '#fd666d'], // Red – 0.85 to 0.90
                [0.5, '#e8c25a'], // Yellow – 0.90 to 0.95
                [1, '#048f04'] // Green – 0.95 to 1.0
            ]
            }
          }, 
          min: 0.85,
          max: 1.0,
          pointer: { itemStyle: { color: 'auto' } },
          axisTick: {
            distance: -10,
            length: 8,
            lineStyle: { color: 'rgb(16,12,42)', width: 2 }
          },
          splitLine: {
            distance: -30,
            length: 30,
            lineStyle: { color: 'rgb(16,12,42)', width: 4 }
          },
          axisLabel: { color: 'inherit', distance: 40, fontSize: 10 }
        }
      ]); 
      const {makeRequest} = useStoreUpdaterWithAPI();
    
     
      const getReposnse =()=>{
        // setLoading(true)
        const currentDate = new Date(); 
      
        const { from, to } = calculateDateRangeFromDate(currentDate, 5, 2);
      
        const inputData = {
          // ConverterID: Number(lgConvId),
          // MeterIds: ids,
          FromDate: from,  
          ToDate:to,
        }; 
        console.log('getReposnse')
        console.log(to, from)   
      const dummy=[
        {
          "groupID": 1,
          "groupName": "Incomer",
          "meterName": "HEATPUMP",
          "meterID": 4,
          "kwt": 96,
          "iavg": 149,
          "v_LLAvg": 410,
          "kvat": 106,
          "pft": 0
        }
      ]
       
        try {      
          makeRequest({
            type: APIConstants.GET,     
            // http://20.244.40.160:83/SF6VCBConsumptiontrend?FromDate=2024-08-20%2006%3A00%3A00.000&ToDate=2024-08-20%2007%3A00%3A00.000
            url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=${from}&ToDate=${to}`
            // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
            // token:token, 
            // body:chartInput      
          }).then((res) => {  
            console.log('response' )
            console.log(res)       
            // console.log(TransformGaugeChartData(res[0])) 
            if (res&& res.length > 0) {
              setGauge(TransformGaugeChartData(res[0],props.theme));              
            }
            // console.log(TransformGaugeChartData(res[0]));              
            // setGauge(TransformGaugeChartData(dummy[0]));
    
           
            
      
          });
          // console.log('function  called') 
          
        } catch (error) {
          // setError(true);
          console.log(error);
        }  
      
      }
    
      console.log(gauge)
    
      useEffect(()=>{
        getReposnse()
        const intervalId = setInterval(() => {
            getReposnse();
          }, 60000); // 60000 milliseconds = 1 minute
      
          return () => clearInterval(intervalId); // Cleanup on unmount
      },[props.theme]) 
      
          
  return (
    <div className="flex flex-wrap xl:flex-nowrap md:justify-between justify-center items-center  gap-y-5 gap-5 m-5 ">   
        {gauge && gauge.map((series, index) => {
          return ( 
            <GaugeChart series={series} key={index} theme={props.theme} />
          ); 
        })}     
      </div>
  )
}

export default GaugeMain